import PropTypes from "prop-types";

export const TagsFilterProps = {
    filter: PropTypes.func,
    clear: PropTypes.func,
    tags: PropTypes.object.isRequired,
    handleClick: PropTypes.func,
    activeFilters: PropTypes.arrayOf(PropTypes.string),
    useUrls: PropTypes.bool,
};

export const TagFilterProps = {
    active: PropTypes.bool,
    icon: PropTypes.string,
    displayText: PropTypes.string,
    setActive: PropTypes.func,
    isUrl: PropTypes.bool,
    url: PropTypes.string,
};
